import { useFeatureIsOn } from '@growthbook/growthbook-react'

export const useIsClientAiSubscriptionEnabled = () => {
  return useFeatureIsOn('hedepy-ai-subscription')
}
